import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

function Home() {
  const navigate = useNavigate();
  const [isJoining, setIsJoining] = useState(false);
  const [partyCode, setPartyCode] = useState('');
  const [participantName, setParticipantName] = useState('');
  const [bannerMessage, setBannerMessage] = useState('');
  const [bannerColor, setBannerColor] = useState('');

  const startParty = () => {
    navigate('/host');
  };

  const joinParty = () => {
    setIsJoining(true);
  };

  const handlePartyCodeSubmit = async () => {
    setBannerMessage('');

    try {
      await api.getParty(partyCode);
      setBannerMessage('Success!');
      setBannerColor('green');
      navigate('/role-selection', { state: { participantName, partyCode } });
    } catch (error) {
      console.error('Error checking party code:', error);
      setBannerMessage('Party code invalid.');
      setBannerColor('red');
    }

    setPartyCode('');
    setParticipantName('');
  };

  return (
    <div className="home-container">
      <h1>Welcome to Movie Party</h1>
      {bannerMessage && (
        <div className="banner" style={{ backgroundColor: bannerColor }}>
          {bannerMessage}
        </div>
      )}
      <div className="button-container">
        {!isJoining ? (
          <>
            <button onClick={startParty} className="action-button">Start a Party</button>
            <button onClick={joinParty} className="action-button-secondary">Join a Party</button>
          </>
        ) : (
          <div className="join-party-container">
            <input
              type="text"
              value={participantName}
              onChange={(e) => setParticipantName(e.target.value)}
              placeholder="Your Name"
              className="input-field"
            />
            <input
              type="text"
              value={partyCode}
              onChange={(e) => setPartyCode(e.target.value)}
              placeholder="Enter Party Code"
              className="input-field"
            />
            <button onClick={handlePartyCodeSubmit} className="action-button">Submit Party Code</button>
          </div>
        )}
      </div>
      
      <div className="instructions">
        <h2 style={{ textAlign: 'center' }}>The best way to watch movies with friends</h2>
        <p>1. <strong>Start a Party:</strong> Get some friends together and start a party</p>
        <p>2. <strong>Join a Party:</strong> Share the invite link or party code with the group</p>
        <p>3. <strong>Choose a Judge:</strong> Decide who will be the judge</p>
        <p>4. <strong>Submit Movies:</strong> Everyone submits one movie anonymously for the judge</p>
        <p>5. <strong>Selection:</strong> Judges can view all submitted movies and make selections.</p>
      </div>

      <style jsx>{`
        .instructions {
          margin-top: 30px;
          width: 90%;
          max-width: 600px;
          padding: 15px;
          border-radius: 10px;
          font-size: 14px;
          line-height: 1.4;
          text-align: left;
          border: 2px solid #333;
        }

        .instructions p {
          margin: 5px 0;
        }

        .instructions strong {
          color: #FF4040;
        }

        .join-party-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }
      `}</style>
    </div>
  );
}

export default Home;
